import {addImpression} from "../../utils/addImpression";
import {decorateDateString} from "../../utils/decorateDateString";
export function populateVideoBox(entry, container, timelineElement) {
    if (container[0]?.classList.contains("already-loaded")) {
        return;
    } else {
        container?.[0]?.classList.add("already-loaded");
    }
    container.addClass("video");
    var clonedBox = $(".video_box_prototype").clone().appendTo(container);
    clonedBox.removeClass("video_box_prototype");
    clonedBox.removeClass("hidden");
    clonedBox.addClass("video_box");
    clonedBox.find(".headline").prepend(entry.description);
    clonedBox.find("input[type=\"hidden\"][name=\"post_id\"]").val(entry.id);
    clonedBox.find(".prost_count").text(entry.sum_prosts);
    clonedBox.find(".comment_count").text(entry.sum_comments);
    clonedBox.find(".js-post-date").text(decorateDateString(timelineElement.post_date));
    clonedBox.find(".js-author-comment").html(entry.content);
    if (entry.youtube_code) {
        // Find the old iframe inside the cloned box
        const oldIframe = clonedBox.find("iframe");

        // Create a new iframe
        const newIframe = $('<iframe>');

        // Copy all attributes from the old iframe
        $.each(oldIframe[0].attributes, function() {
            newIframe.attr(this.name, this.value);
        });

        // Update the src to the new YouTube embed
        newIframe.attr(
            'src',
            `https://www.youtube.com/embed/${entry.youtube_code}?rel=0&modestbranding=1`
        );

        // Replace the old iframe with the new one
        oldIframe.replaceWith(newIframe);
    }

    clonedBox.find(".spinner").hide();
    if (timelineElement !== undefined) {
        addImpression(timelineElement.id);
    }
}